var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExitIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25652_248426)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 1.5C2.73478 1.5 2.48043 1.60536 2.29289 1.79289C2.10536 1.98043 2 2.23478 2 2.5V13.5C2 13.7652 2.10536 14.0196 2.29289 14.2071C2.48043 14.3946 2.73478 14.5 3 14.5H10.5C10.6326 14.5 10.7598 14.4473 10.8536 14.3536C10.9473 14.2598 11 14.1326 11 14C11 13.8674 10.9473 13.7402 10.8536 13.6464C10.7598 13.5527 10.6326 13.5 10.5 13.5H3V2.5H10.5C10.6326 2.5 10.7598 2.44732 10.8536 2.35355C10.9473 2.25979 11 2.13261 11 2C11 1.86739 10.9473 1.74021 10.8536 1.64645C10.7598 1.55268 10.6326 1.5 10.5 1.5H3ZM12.604 5.396C12.5101 5.30211 12.3828 5.24937 12.25 5.24937C12.1172 5.24937 11.9899 5.30211 11.896 5.396C11.8021 5.48989 11.7494 5.61722 11.7494 5.75C11.7494 5.88278 11.8021 6.01011 11.896 6.104L13.293 7.5H6.5C6.36739 7.5 6.24021 7.55268 6.14645 7.64645C6.05268 7.74021 6 7.86739 6 8C6 8.13261 6.05268 8.25979 6.14645 8.35355C6.24021 8.44732 6.36739 8.5 6.5 8.5H13.293L11.896 9.896C11.8021 9.98989 11.7494 10.1172 11.7494 10.25C11.7494 10.3828 11.8021 10.5101 11.896 10.604C11.9899 10.6979 12.1172 10.7506 12.25 10.7506C12.3828 10.7506 12.5101 10.6979 12.604 10.604L14.854 8.354C14.9006 8.30755 14.9375 8.25238 14.9627 8.19163C14.9879 8.13089 15.0009 8.06577 15.0009 8C15.0009 7.93423 14.9879 7.86911 14.9627 7.80837C14.9375 7.74762 14.9006 7.69245 14.854 7.646L12.604 5.396Z",
    fill: "#E77B7B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25652_248426"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExitIcon);
export default __webpack_public_path__ + "static/media/exitIcon.c895fadc3e39bd9a08496c3b8095b001.svg";
export { ForwardRef as ReactComponent };